import React, { memo, useEffect, useRef, useState } from "react";
import { Nav, Tab } from "react-bootstrap";

const TabPane = memo((props) => {
  const { tabs, setSelectedTabId, selectedTabId } = props;
  const [activeTab, setActiveTab] = useState();
  const firstRender = useRef(true);
  const[orderedTabs,setOrderedTabs] = useState([])
  
  useEffect(() => {
  // ESTA SECCION SE ENCARGA DE SELECCIONAR LOS TABS SEGUN LOS KEY QUE RECIBE
  if (tabs?.length > 0 && selectedTabId) {
    if(selectedTabId == 0){
      tabs.sort((a, b) => a.orden - b.orden);
      setActiveTab(tabs[0].key);
      setSelectedTabId(tabs[0].key);
      setOrderedTabs(tabs);
      return
    }else{
      tabs.sort((a, b) => a.orden - b.orden);
      setActiveTab(selectedTabId);
      setSelectedTabId(selectedTabId);
      setOrderedTabs(tabs);
      return
    }
  } else if(firstRender.current && tabs?.length > 0){
    tabs.sort((a, b) => a.orden - b.orden);
    setActiveTab(tabs[0].key);
    setSelectedTabId(tabs[0].key);
    setOrderedTabs(tabs);
    firstRender.current = false;
    return
  }

  // ORIGINAL
  // if (firstRender.current && tabs?.length > 0) {
  //     tabs.sort((a, b) => a.orden - b.orden);
  //     setActiveTab(tabs[0].key);
  //     setSelectedTabId(tabs[0].key);
  //     setOrderedTabs(tabs);
  //     firstRender.current = false;
  //     return
  // }

  if(tabs?.length > 0){
    tabs.sort((a, b) => a.orden - b.orden);
    setOrderedTabs(tabs);
  }
}, [tabs]);
  const onClickTab = (tabsKey) => {
    if (setSelectedTabId && tabsKey != null) {
      setSelectedTabId(tabsKey);
    }
  };

  return (
    <Tab.Container activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
      <Nav variant="tabs">
        {orderedTabs?.map((tab) => (
          <Nav.Item key={tab.key}>
            <Nav.Link onClick={() => onClickTab(tab.key)} eventKey={tab.key}>
              {tab.title}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <Tab.Content>
        {orderedTabs?.map((tab) => (
          <Tab.Pane key={tab.key} eventKey={tab.key}>
            {tab.content}
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
});

export default TabPane;
